/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface BorrowerMinimalLegalEntityDto
 */
export interface BorrowerMinimalLegalEntityDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    borrowerId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    phone: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    address: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerMinimalLegalEntityDto
     */
    registrationNumber: string;
}

/**
 * Check if a given object implements the BorrowerMinimalLegalEntityDto interface.
 */
export function instanceOfBorrowerMinimalLegalEntityDto(value: object): value is BorrowerMinimalLegalEntityDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    return true;
}

export function BorrowerMinimalLegalEntityDtoFromJSON(json: any): BorrowerMinimalLegalEntityDto {
    return BorrowerMinimalLegalEntityDtoFromJSONTyped(json, false);
}

export function BorrowerMinimalLegalEntityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerMinimalLegalEntityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'borrowerId': json['borrowerId'],
        'type': json['type'],
        'email': json['email'],
        'phone': json['phone'],
        'address': AddressDtoFromJSON(json['address']),
        'companyName': json['companyName'],
        'registrationNumber': json['registrationNumber'],
    };
}

export function BorrowerMinimalLegalEntityDtoToJSON(json: any): BorrowerMinimalLegalEntityDto {
    return BorrowerMinimalLegalEntityDtoToJSONTyped(json, false);
}

export function BorrowerMinimalLegalEntityDtoToJSONTyped(value?: BorrowerMinimalLegalEntityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'borrowerId': value['borrowerId'],
        'type': value['type'],
        'email': value['email'],
        'phone': value['phone'],
        'address': AddressDtoToJSON(value['address']),
        'companyName': value['companyName'],
        'registrationNumber': value['registrationNumber'],
    };
}

